var TYPE_OPTIONS = {
  HELP: "help",
  ERROR: "error"
};
export default TYPE_OPTIONS;